export enum Substance {
    PM25 = 'PM25',
    PM10 = 'PM10',
    NO2 = 'NO2',
    SO2 = 'SO2',
}
